import { render } from "./submenu.vue?vue&type=template&id=7f4386cd"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"
script.render = render

export default script